module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_valge_ikoon.8e8ca595.svg";